import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { IconButton, Tooltip } from "@mui/material";

const Back = () => {
  const navigate = useNavigate();

  const handleBack = () => navigate(-1);

  return (
    <Tooltip title="Back">
      <IconButton onClick={handleBack}>
        <ArrowBackIosNewIcon color="inherit" fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default Back;
